/* eslint-disable import/no-import-module-exports */
// Without disabling this rule, TS imports into JS seem to break.  Can be removed
// after the file (and all imports) are converted to TS.
// see: https://github.com/import-js/eslint-plugin-import/blob/main/docs/rules/no-import-module-exports.md
import React, { useMemo, useState } from "react";

import { createBlankCrop, useTranslation } from "utils";

import { Button, Icon, Timeline, Tooltip } from "components";

import { CropSplitCard } from "pages/app/modules/components/Crop/CropSplitCard";
import { CropsForm } from "pages/app/modules/components/Crop/CropsForm";

export const CropsBaselineYear = ({ allCrops, existingCrops, fieldId, forms, onDeleteCrop, onUpdate, year, dataTestId }) => {
  const { t } = useTranslation(["modules"]);
  const defaultCrops = existingCrops || [createBlankCrop({ isMain: true })];
  const [crops, setCrops] = useState(defaultCrops);

  const mainCrops = useMemo(() => crops.filter((crop) => crop.mainCrop === true), [crops]);
  const hasMultipleMainCrops = mainCrops.length > 1;
  const hasNoMainCrop = mainCrops.length === 0;

  const addNewCrop = () => {
    const updatedCrops = [...crops, createBlankCrop({ isMain: hasNoMainCrop })];
    setCrops(updatedCrops);
    onUpdate("crops", year, updatedCrops);
  };

  const deleteCrop = (index) => {
    const cropsCopy = [...crops];
    cropsCopy.splice(index, 1);
    setCrops(cropsCopy);
    onDeleteCrop("crop", crops[index].ide);
    onUpdate("crops", year, cropsCopy);
  };

  const updateCrop = (index, v) => {
    const cropsCopy = [...crops];
    cropsCopy[index] = { ...cropsCopy[index], ...v };
    setCrops(cropsCopy);
    onUpdate("crops", year, cropsCopy);
  };

  const moveUp = (index) => {
    const cropsCopy = [...crops];
    const cropToMove = cropsCopy.splice(index, 1);
    cropsCopy.splice(index - 1, 0, ...cropToMove);
    setCrops(cropsCopy);
    onUpdate("crops", year, cropsCopy);
  };

  const moveDown = (index) => {
    const cropsCopy = [...crops];
    const cropToMove = cropsCopy.splice(index, 1);
    cropsCopy.splice(index + 1, 0, ...cropToMove);
    setCrops(cropsCopy);
    onUpdate("crops", year, cropsCopy);
  };

  const showSplitFieldCard = crops.some(
    (selectedCrop) => allCrops.crops && allCrops.crops.find((crop) => crop.id === selectedCrop.cropId && crop.recommendSplit)
  );

  return (
    <div className="baseline-form" data-testid={dataTestId}>
      <div className="fertilizer-bau-form">
        <div className="baseline-year-header-row">
          <h2>{year}</h2>
        </div>
        <Timeline
          className="bau-timeline"
          mode="left"
          items={[
            <>
              <p className="year-label margin-bottom-200">{`${t("bauEntryDrawer.jan")} ${year}`}</p>
              {crops.map((crop, index) => (
                <div key={crop.key || crop.id}>
                  <CropsForm
                    cropId={crop.cropId}
                    crops={allCrops.crops}
                    currentCrop={crops.find((item) => item.id === crop.cropId)}
                    forms={forms}
                    index={index}
                    mainCrop={crop.mainCrop}
                    moveDown={moveDown}
                    moveUp={moveUp}
                    selectedCrops={crops}
                    topCrops={allCrops.topCrops}
                    year={year}
                    onDelete={deleteCrop}
                    onUpdate={updateCrop}
                    dataTestId={`${dataTestId}-form`}
                    showMultipleMainCropsWarning={hasMultipleMainCrops}
                  />
                </div>
              ))}
              <div className="margin-bottom-75">
                <Tooltip placement="bottom" title={t("bauEntryDrawer.crops.addSideCropTooltip")}>
                  <Button type="text" icon={<Icon iconName="klim/plus" className="icon inline" />} onClick={addNewCrop}>
                    {hasNoMainCrop ? "Add new main crop" : t("bauEntryDrawer.crops.addSideCrop")}
                  </Button>
                </Tooltip>
              </div>
            </>,
            <p className="year-label" key={0}>{`${t("bauEntryDrawer.dec")} ${year}`}</p>,
          ].map((content) => ({
            content: content,
          }))}
        />
        {showSplitFieldCard && (
          <div className="field-split-card-container">
            <CropSplitCard fieldId={fieldId} />
          </div>
        )}
      </div>
    </div>
  );
};
